import { type ReactElement } from 'react';
import { type ParkingGbgProperties } from '../Sources/ParkingsGbg/ParkingBase';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function BikeParking(properties: ParkingGbgProperties): ReactElement {
    return (
        <PopupTemplateWrapper iconId={208} title="Cykelparkering">
            <div className="">
                <h3>{properties.address}</h3>
                <p>{properties.spaces} platser</p>
            </div>
        </PopupTemplateWrapper>
    );
}
